import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getHomeStats } from "@/lib/homeStats.functions";
import { getCompareFeed } from "@/lib/compareFeed.functions";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const Home = lazy(() => import("@/pages/Home"));

export const Route = createFileRoute("/")({
  head: () => seoHead("/"),
  loader: async () => {
    // Flödet hämtas här så att sektionen finns i server-HTML:en och inte
    // skjuter ner resten av sidan när det laddas på klienten.
    // Spotpriserna hämtas också här, så att korten och tabellerna har riktiga
    // priser i server-HTML:en i stället för tomma rader och "0.00".
    const [stats, feed, { spotSnapshot }] = await Promise.all([
      getHomeStats(),
      getCompareFeed().catch(() => ({ items: [] })),
      spotPriceLoader(),
    ]);
    return { stats, feed, spotSnapshot };
  },
  component: () => <Home />,
});
